import { makeStyles } from '@material-ui/core/styles';
export default makeStyles(function (theme) {
  return {
    root: {
      padding: 0,
      '&:hover': {
        backgroundColor: 'transparent !important'
      },
      '&.Mui-focusVisible': {
        outline: `${theme.palette.sapphire[500]} dashed 2px`,
        outlineOffset: '2px',
        borderRadius: 0
      }
    },
    icon: {
      borderRadius: 1,
      width: 24,
      height: 24,
      boxShadow: `inset 0 0 0 1px ${theme.palette.neutral.fog}`,
      backgroundColor: theme.palette.common.white,
      backgroundImage: 'none',
      position: 'relative',
      'input:hover ~ &': {
        boxShadow: `inset 0 0 0 2px ${theme.palette.sapphire[500]}`
      },
      'input:active ~ &': {
        boxShadow: `inset 0 0 0 2px ${theme.palette.sapphire[900]}`
      },
      'input:disabled ~ &': {
        backgroundColor: theme.palette.common.white,
        boxShadow: `inset 0 0 0 1px ${theme.palette.neutral.stainless}`
      }
    },
    iconRed: {
      boxShadow: `inset 0 0 0 1px ${theme.palette.cardinal[500]}`,
      backgroundColor: theme.palette.cardinal[50],
      'input:hover ~ &': {
        backgroundColor: theme.palette.common.white,
        boxShadow: `inset 0 0 0 2px ${theme.palette.cardinal[500]}`
      },
      'input:active ~ &': {
        boxShadow: `inset 0 0 0 2px ${theme.palette.cardinal[900]}`
      },
      'input:disabled ~ &': {
        backgroundColor: theme.palette.common.white,
        boxShadow: `inset 0 0 0 1px ${theme.palette.neutral.stainless}`
      }
    },
    checkedIcon: {
      backgroundColor: theme.palette.sapphire[500],
      backgroundImage: 'none',
      boxShadow: `inset 0 0 0 1px ${theme.palette.sapphire[500]}`,
      'input:hover ~ &': {
        boxShadow: `inset 0 0 0 2px ${theme.palette.sapphire[700]}`
      },
      'input:active ~ &': {
        backgroundColor: theme.palette.sapphire[900],
        boxShadow: `inset 0 0 0 2px ${theme.palette.sapphire[900]}`
      },
      'input:disabled ~ &': {
        backgroundColor: theme.palette.sapphire[100],
        boxShadow: `inset 0 0 0 2px ${theme.palette.sapphire[100]}`
      }
    },
    checkedIconRed: {
      backgroundColor: theme.palette.cardinal[500],
      boxShadow: `inset 0 0 0 1px ${theme.palette.cardinal[500]}`,
      'input:hover ~ &': {
        backgroundColor: theme.palette.cardinal[500],
        boxShadow: `inset 0 0 0 2px ${theme.palette.cardinal[700]}`
      },
      'input:active ~ &': {
        boxShadow: `inset 0 0 0 2px ${theme.palette.cardinal[900]}`,
        backgroundColor: theme.palette.cardinal[900]
      },
      'input:disabled ~ &': {
        backgroundColor: theme.palette.cardinal[100],
        boxShadow: `inset 0 0 0 2px ${theme.palette.cardinal[100]}`
      }
    },
    indeterminateIconLine: {
      backgroundColor: theme.palette.common.white,
      display: 'inline-block',
      height: 2,
      width: 12,
      position: 'absolute',
      top: 11,
      left: 6
    },
    checkMark: {
      color: theme.palette.common.white,
      position: 'absolute',
      width: 15,
      height: 13,
      top: 6,
      left: 5
    }
  };
}, {
  name: 'PdsCheckbox'
});